<template>
	<el-dialog :visible.sync="dialogShow" :close-on-click-modal="false" :append-to-body="true" custom-class="radius5" width="420px" title="添加项目成员">
		<el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="keyword">
		</el-input>

		<div class="my-dropdown3 bg-white">
			<el-scrollbar style="height:360px" :native="false" :noresize="true" tag="ul">
				<div v-for="item in showList" :key="item.uid" class="flex down-item pr pl pt-sm pb-sm  mt-sm">
					<div class="hd flex-center mr" :class="[item.selected&&'bg-primary',!item.selected&&'border']" @click="handleChange(item)">
						<i v-if="item.selected" class="el-icon-check text-white text-bold"></i>
					</div>
					<span class="bd flex align-items-center" @click="handleChange(item)">
						<f-user-avatar :user="item" :preview="false" size="mini" role="button" />
						<!-- <img v-if="item.avatar" :src="item.avatar" alt="" class="image sm circle" />
						<img v-else src="@/assets/default-avatar.png" alt="" class="image circle sm" /> -->
						<span class="ml-xs ellipsis">{{ item.username }}</span>
					</span>
					<div class="ft">
						<level-pulldown :item="item" @change="handleMemberChange($event,item)" />
					</div>
				</div>
			</el-scrollbar>

		</div>
		<template slot="footer">
			<div class="flex-center">
				<el-button @click="dialogShow = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import LevelPulldown from './LevelPulldown.vue'
import { getAddUserList, addMemberApi } from '@/api/pm/memberApi'
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		}
	},

	components: {
		LevelPulldown
	},
	data () {
		return {
			allList: [],
			keyword: ''
		}
	},
	computed: {
		dialogShow: {
			get () {
				return this.show
			},
			set (val) {
				this.$emit('update:show', val)
			}
		},
		showList () {
			return this.allList.filter(item => {
				return item.username.indexOf(this.keyword) > -1 || this.acIds.indexOf(item.uid) > -1
			})
		},

		pid () {
			return Number(this.$store.state.middleStore.tmpProjectid)
		}
	},

	created () {
		this.getAllM()
	},
	methods: {
		getAllM () {
			getAddUserList({
				projectid: this.pid,
				keyword: this.keywords
			}).then(res => {
				this.allList = res.data.map(item => {
					item['permission'] = 2
					item['selected'] = false
					return item
				})
			})
		},

		handleChange (item) {
			item.selected = !item.selected
		},

		handleMemberChange (e, item) {
			item.permission = e
		},

		submit () {
			let arr = []
			if (this.showList.length) {
				this.showList.forEach(item => {
					if (item.selected) {
						arr.push({
							uid: item.uid,
							permission: item.permission
						})
					}
				})
			}
			if (!arr.length) {
				return
			}
			let setdata = {
				projectid: this.pid,
				list: arr
			}

			addMemberApi(setdata).then(res => {
				if (!res.errno) {
					this.$message.success('添加人员成功！')
					this.dialogShow = false
					this.$emit('success')
				} else {
					this.$message.error(res.message)
				}
			})


		}
	}
}
</script>

<style lang="scss" scoped>
.my-dropdown3 {
	padding: 10px 0px;
	border-radius: 4px;
	background-color: #fff;
}

.down-item {
	padding: 10px;
	cursor: pointer;
	transition: all 0.2s;
	align-items: center;
	&:hover {
		background-color: rgba(153, 153, 153, 0.2);
	}
	.hd {
		height: 20px;
		width: 20px;
		border-radius: 50%;
	}
	.border {
		border: 1px solid rgba(153, 153, 153, 1);
	}
}
</style>